// extracted by mini-css-extract-plugin
module.exports = {"Description":"AddUserModal_Description__36Hk_","MultiSelectDropdown":"AddUserModal_MultiSelectDropdown__13-oe","RolesContainer":"AddUserModal_RolesContainer__3e1oJ"};